import styled from 'styled-components';
import { CaptionBoldLUppercase } from '../../../../../../styles/globals';
import { IThemeProvider } from '../../../../../../styles/theme';

export const Wrapper = styled.div`
  place-self: center;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
`;

export const Header = styled(CaptionBoldLUppercase)`
  margin-bottom: 1rem;
`;

export const Table = styled.table`
  width: 100%;
`;

export const HeaderRow = styled.tr`
  display: grid;
  grid-template-columns: 5fr 2fr 2fr;
  margin-bottom: 0.5rem;
`;

export const HeaderCell = styled.th<IThemeProvider>`
  font-weight: 700;
  letter-spacing: 0.07px;
  font-size: 14px;
  display: flex;
  align-items: center;
  justify-content: center;
  line-height: 16px;
  text-transform: uppercase;

  ${({ theme }) => `
    color:  ${theme.colors.neutral.primary[80]};
  `}
  &:first-child {
    justify-content: left;
    margin-left: 1rem;
  }
`;
